import React, { useEffect, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import './Uploader.scss';
import {decorate, observable, action, isObservableObject, toJS} from 'mobx';
import { observer, inject } from 'mobx-react';
import FeatherIcon from "feather-icons-react";
import {Button} from "shards-react";

const maxFiles = 6;
const maxSizeMb = 4.5; // 5MB
const maxSize = maxSizeMb * 1024 * 1024; // 5MB

const getMediaType = (file) => {
    let type;
    if(file.type.indexOf('image/') > -1) {
        type = 'image';
    }
    else if(file.type.indexOf('video/') > -1) {
        type = 'video';
    }
    return type;
};

const byteToMb = (bytes) => {
    return (bytes / (1024 * 1024)).toFixed(2) + 'MB';
}

function Uploader(props) {

    const [files, setFiles] = useState([]);
    const [orgfiles, setOrgFiles] = useState([]);
    const { getRootProps, getInputProps } = useDropzone({
        accept: 'image/*',
        maxFiles: maxFiles,
        multiple: true,
        onDrop: async (acceptedFiles, fileRejections) => {
            await setOrgFiles(prevOrgFiles => [...prevOrgFiles, ...acceptedFiles]);
            if (fileRejections.length > 0 && fileRejections.some(f => f.errors.some(e => e.code === "too-many-files"))) {
                alert(`최대 ${maxFiles}개의 파일만 업로드할 수 있습니다.`);
            }
            const newFiles = acceptedFiles.reduce((acc, file) => {
                if (file.size > maxSize) {
                    alert(file.name + ' 파일이 너무 큽니다. 최대 5MB까지 업로드 가능합니다.');
                    return acc; // 파일을 결과 배열에 추가하지 않고 현재의 누적값을 그대로 반환
                } else {
                    // 파일 정보를 새로운 객체로 만들어 배열에 추가
                    const fileWithMetaData = {
                        ...file,
                        id: file.name + file.lastModified, // 고유 식별자 생성
                        name: file.name,
                        size: file.size, // 파일 사이즈를 MB 단위로 변환
                        preview: URL.createObjectURL(file) // 파일 미리보기 URL 생성
                    };
                    acc.push(fileWithMetaData); // 조건에 맞는 파일만 누적 배열에 추가
                    return acc;
                }
            }, []);
            await setFiles(prevFiles => [...prevFiles, ...newFiles]);
            // const newFiles = acceptedFiles.map(file => {
            //     return {
            //     ...file,
            //     id: file.name + file.lastModified, // 고유 식별자 생성
            //     name: file.name,
            //     size: byteToMb(file.size),
            //     preview: URL.createObjectURL(file)
            //     }
            // });
            // await setFiles(prevFiles => [...prevFiles, ...newFiles]);
        }
    });

    // Clean up URLs to prevent memory leaks
    useEffect(() => {
        props.getFiles(orgfiles);
        return () => files.forEach(file => URL.revokeObjectURL(file.preview));
    }, [files]);

    // 파일 삭제 함수
    const removeFile = fileName => {
        setOrgFiles(prevFiles => prevFiles.filter(file => file.name !== fileName));
        setFiles(prevFiles => prevFiles.filter(file => file.name !== fileName));
    };


    const thumbs = files.map(file => (
        <div key={file.id}>
            <ul className="upload-list">
                <li className="item">
                    <div className="img-box">
                        <img
                            alt={file.name}
                            src={file.preview}
                            onLoad={() => {
                                URL.revokeObjectURL(file.preview);
                            }}
                        />
                    </div>
                    <div className="info-box">
                        <p>{file.name}</p>
                        <p className="small-info">{byteToMb(file.size)} bytes</p>
                        <Button className="btn-remove" outline squared size="sm" theme="danger" onClick={e => removeFile(file.name)} ><FeatherIcon icon="x" size="20" className="nd-icon" /></Button>
                    </div>
                </li>
            </ul>
        </div>
    ));

    return (
        <section className="container">
            <div {...getRootProps({className: 'dropzone'})}>
                <input {...getInputProps()} />
                <FeatherIcon icon="upload-cloud" size="70" className="nd-icon upload-icon"/>
                <p>이미지 배너 추가를 위해</p>
                <p>클릭 혹은 파일을 이곳에 드롭하세요.</p>
            </div>
            <aside className="uploadContainer">
                {thumbs}
            </aside>
        </section>
    );
}

export default Uploader;
